import { backendClient } from '@/lib/api-client';
import useSWR, { mutate } from 'swr';
import type { MatterDetail } from '@/types';

// Custom fetcher that uses our apiClient with authentication
const fetcher = async (url: string) => {
  const response = await backendClient.get(url);
  return response.data;
};

const useMatter = (guid?: string) => {
  // Get the slug from the URL if not provided as a parameter
  const getSlugFromUrl = () => {
    const pathParts = window.location.pathname.split('/');
    const slugIndex = pathParts.findIndex(part => part === 'matter') + 1;
    return slugIndex > 0 && slugIndex < pathParts.length ? pathParts[slugIndex] : null;
  };

  const matterSlug = guid || getSlugFromUrl();
  
  // Use the correct endpoint format that matches the backend
  const url = matterSlug && matterSlug !== 'undefined' ? `/matter/${matterSlug}` : null;

  const { data: matter, error, isLoading } = useSWR<MatterDetail>(
    url,
    fetcher
  );

  return {
    isLoading,
    isError: error,
    matter,
    mutateMatter: () => mutate(url),
  };
};

export default useMatter;
